export const urlIsValid = urlToCheck => !!urlToCheck && /^(ftp|http|https):\/\/[^ "]+$/.test(urlToCheck);

export const isEmailValid = emailToCheck => {
    if (!emailToCheck || emailToCheck === '') {
        return false;
    }

    return (
        emailToCheck &&
        (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,63}$/.test(emailToCheck) ||
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/.test(emailToCheck))
    );
};

export const getClearEmail = email => {
    const emailCleared = email?.trim() ?? '';

    if (isEmailValid(emailCleared)) {
        return emailCleared;
    }

    return null;
};

export const onlyNumbersAndSpacesAllowedCheck = checkedString =>
    checkedString !== '' && !/^[\d\s]+$/.test(checkedString);

export const getClearName = name =>
    name?.replace(
        /[^a-zA-Z\-_ ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ ]/g,
        ''
    ) ?? '';

export const httpIsValid = urlToCheck => {
    if (!urlToCheck || typeof urlToCheck !== 'string') {
        return false;
    }

    try {
        const url = new URL(urlToCheck);

        const isValidProtocol = url.protocol === 'http:' || url.protocol === 'https:';
        const hasSlashes = urlToCheck.includes('://');

        return isValidProtocol && hasSlashes;
    } catch {
        return false;
    }
};

export const httpMp4IsValid = urlToCheck => {
    if (!httpIsValid(urlToCheck)) {
        return false;
    }

    try {
        const url = new URL(urlToCheck);
        const hostname = url.hostname.toLowerCase();
        const pathname = url.pathname.toLowerCase();

        return hostname.endsWith('.mp4') || pathname.endsWith('.mp4');
    } catch {
        return false;
    }
};
